import * as R from 'ramda'
import { tableHeaders } from '../components/list/invoice-table/invoice-table-headers'
import actions from './actions'
import { DEFAULT_ACTION_DIALOGS } from './constant'
import getters from './getters'
import { StorageColumnsOrder } from './storageColumnsOrder'
import * as types from './types'

const storageColumnsOrder = StorageColumnsOrder.get()

const DEFAULT_COLUMNS_ORDER = tableHeaders.map((item) => {
  return {
    key: item.key,
    text: item.text,
    align: item.align,
    columnOrderText: item.columnOrderText,
    isSelected: true
  }
})

const INIT_COLUMNS_ORDER = storageColumnsOrder
  ? storageColumnsOrder
  : DEFAULT_COLUMNS_ORDER

const state = {
  invoices: [],
  pagination: {
    sortDesc: [true],
    page: 1,
    itemsPerPage: 20,
    sortBy: ['created_at']
  },
  totalItems: 0,
  isTableLoading: false,
  isCustomColumnsDialogOpen: false,
  defaultColumnsOrder: R.clone(DEFAULT_COLUMNS_ORDER),
  columnsOrderToSave: R.clone(INIT_COLUMNS_ORDER),
  columnsOrder: R.clone(INIT_COLUMNS_ORDER),
  tableHeaders,
  selectedRows: [],
  selectedAction: '',
  isWarningRowShown: false,
  filters: {
    state: ['APPROVED'],
    invoiceNumber: '',
    referenceNumber: '',
    customerCountry: '',
    customerId: '',
    customerRating: '',
    counterpartyCountry: '',
    counterpartyVatNumber: '',
    counterpartyRating: '',
    partnerId: '',
    amountTo: null,
    amountFrom: null,
    currency: '',
    createdAtFrom: '',
    createdAtTo: '',
    creditNoteMatched: '',
    saleState: ''
  },
  actionDialogs: R.clone(DEFAULT_ACTION_DIALOGS),
  isTableSelectAllMode: false,
  timeline: {
    isOpen: false,
    invoiceId: '',
    data: []
  }
}

const mutations = {
  [types.SET_INVOICES]: (state, newInvoices) => {
    state.invoices = newInvoices
  },
  [types.SET_PAGINATION](state, newPagination) {
    state.pagination = newPagination
  },
  [types.SET_TOTAL_ITEMS](state, newTotalItems) {
    state.totalItems = newTotalItems
  },
  [types.SET_IS_TABLE_LOADING](state, turn) {
    state.isTableLoading = turn
  },
  [types.SET_IS_CUSTOM_COLUMNS_DIALOG_OPEN](state, turn) {
    state.isCustomColumnsDialogOpen = turn
  },
  [types.SET_COLUMNS_ORDER_TO_SAVE](state, newColumnsOrderToSave) {
    state.columnsOrderToSave = newColumnsOrderToSave
  },
  [types.SET_COLUMNS_ORDER](state, newColumnsOrder) {
    state.columnsOrder = newColumnsOrder
  },
  [types.SET_SELECTED_ROWS](state, newSelectedRows) {
    state.selectedRows = newSelectedRows
  },
  [types.SET_SELECTED_ACTION](state, newSelectedAction) {
    state.selectedAction = newSelectedAction
  },
  [types.SET_IS_WARNING_ROW_SHOWN](state, turn) {
    state.isWarningRowShown = turn
  },
  [types.SET_FILTERS](state, { key, value }) {
    state.filters = {
      ...state.filters,
      [key]: value
    }
  },
  [types.SET_ACTION_DIALOGS](state, newActionDialogs) {
    let newValue

    // If newActionDialogs param is passed, update the value. If not, just reset to default
    if (newActionDialogs) {
      const { invoices, isBulk, key, turn } = newActionDialogs

      newValue = {
        invoices: invoices,
        isBulk: isBulk,
        isOpen: {
          ...state.actionDialogs.isOpen,
          [key]: turn
        }
      }
    } else {
      newValue = R.clone(DEFAULT_ACTION_DIALOGS)
    }

    state.actionDialogs = newValue
  },
  [types.SET_IS_TABLE_SELECT_ALL_MODE](state, turn) {
    state.isTableSelectAllMode = turn
  },
  [types.SET_TIMELINE](state, newTimeline) {
    state.timeline = newTimeline
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
